<router-outlet></router-outlet>

<!-- Global Help Modal -->
<app-workflow-help-panel></app-workflow-help-panel>